/**
 * Quita el sufijo de categoría que traen las subcategorías del proveedor
 * (" - Aut", " - Ofi", " - Beb", " - Varie -", etc.) y normaliza espacios.
 * Ej: "Botellas y Botilitos -  Metálicos - Beb" → "Botellas y Botilitos - Metálicos"
 */
const cleanSubcategoryName = (name) => {
  if (!name) return name;
  return name
    .replace(/\s+-\s*[A-Za-zÀ-ÿ]{2,5}\s*-?\s*$/, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
};

export default cleanSubcategoryName;
